import { Utils } from 'versafleet-core';

const { RequestHelper: { request } } = Utils;

function receiveVersadriveSetting(versadriveSetting) {
  return {
    type: 'RECEIVE_VERSADRIVE_SETTING',
    versadriveSetting,
  };
}

function fetchVersadriveSetting() {
  return async (dispatch) => {
    const result = await request('/versadrive_settings', {
      method: 'GET',
    });
    dispatch(receiveVersadriveSetting(result.versadrive_setting));
  };
}

export default {
  fetchVersadriveSetting,
};
